import ActionsBar from 'components/ActionsBar';
import moment from 'moment';
import numeral from 'numeral';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Badge, Col, Row } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import like from '../../../assets/img/bell.png';
import Button from '../../../components/CustomButton/CustomButton';
import * as K from '../redux/QuotationsConstants';

class flightQuotation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openConfirm: false,
      indexToDelete: 0,
    };
  }

  handleEdit = (index) => {
    var newQuotation = immutable.set(
      this.props.Quotations,
      ['indexToEdit'],
      index
    );
    newQuotation = immutable.set(
      newQuotation,
      ['dataToEdit', 'flight'],
      this.props.Quotations.flights[index]
    );

    this.props.dispatch({
      type: K.SETSTATE,
      payload: newQuotation,
    });

    this.props.dispatch({
      type: K.OPEN_MODAL_ADD,
      payload: 'flight',
    });
  };

  handleDelete(confirm = false, index) {
    if (confirm) {
      var newArray = immutable.del(this.props.Quotations, [
        'flights',
        this.state.indexToDelete,
      ]);
      this.props.dispatch({
        type: K.SETSTATE,
        payload: newArray,
      });
      this.setState({ openConfirm: false });
    } else {
      this.setState({ openConfirm: true, indexToDelete: index });
    }
  }

  handleAdd = () => {
    this.props.dispatch({
      type: K.OPEN_MODAL_ADD,
      payload: 'flight',
    });
  };

  render() {
    const {
      Quotations: {
        flights,
        generalQuotation: { isPackage = false },
      },
    } = this.props;
    let { openConfirm } = this.state;

    return (
      <div style={{ textAlign: 'justify' }}>
        <Row>
          <Col md={12}>
            {flights.map((flight, index) => {
              return (
                <div key={index} style={{ marginBottom: '30px' }}>
                  {openConfirm && (
                    <SweetAlert
                      warning
                      style={{ display: 'block', marginTop: '-100px' }}
                      title="¿Estás Seguro?"
                      onConfirm={() => this.handleDelete(true)}
                      onCancel={() => this.setState({ openConfirm: false })}
                      confirmBtnBsStyle="info"
                      cancelBtnBsStyle="danger"
                      confirmBtnText="Si, borrar!"
                      cancelBtnText="Cancelar"
                      showCancel
                    >
                      No podrás desaser está opción!
                    </SweetAlert>
                  )}
                  <ActionsBar
                    onEdit={() => this.handleEdit(index)}
                    onDelete={() => this.handleDelete(false, index)}
                  />
                  <br />
                  <Row>
                    <Col md={12}>
                      <div className="form-group">
                        {flight.like !== undefined && flight.like === true ? (
                          <div>
                            <img
                              src={like}
                              style={{ width: '35px', marginLeft: 0 }}
                              alt="likeImg"
                            />
                            <span
                              style={{
                                color: '#e70a24',
                                fontSize: '15px',
                                fontWeight: 'bold',
                              }}
                            >
                              Interés
                            </span>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    </Col>
                  </Row>

                  {flight.flights.map((flight, index) => (
                    <div key={index}>
                      <Row>
                        <Col md={3}>
                          <div className="form-group">
                            <br />

                            {flight.type !== undefined &&
                            flight.type === 'ida' ? (
                              <Badge
                                style={{
                                  backgroundColor: '#467aa7',
                                  color: '#fff',
                                  fontWeight: 'ligher',
                                  marginRight: '5px',
                                }}
                              >
                                IDA
                              </Badge>
                            ) : (
                              ''
                            )}
                            {flight.type !== undefined &&
                            flight.type === 'regreso' ? (
                              <Badge
                                style={{
                                  backgroundColor: '#797b78',
                                  color: '#fff',
                                  fontWeight: 'ligher',
                                  marginRight: '5px',
                                }}
                              >
                                REGRESO
                              </Badge>
                            ) : (
                              ''
                            )}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={3}>
                          <div className="form-group">
                            <label
                              style={{ fontWeight: 'bold' }}
                              htmlFor="client"
                            >
                              AEROLÍNEA
                            </label>
                            <br />
                            <span>{flight.airline}</span>
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="form-group">
                            <label
                              style={{ fontWeight: 'bold' }}
                              htmlFor="client"
                            >
                              NÚMERO DE VUELO
                            </label>
                            <br />
                            <span>{flight.flightNumber}</span>
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="form-group">
                            <label
                              style={{ fontWeight: 'bold' }}
                              htmlFor="client"
                            >
                              ORIGEN
                            </label>
                            <br />
                            <span>{flight.originatingCity}</span>
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="form-group">
                            <label
                              style={{ fontWeight: 'bold' }}
                              htmlFor="client"
                            >
                              DESTINO
                            </label>
                            <br />
                            <span>{flight.destinationCity}</span>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <div className="form-group">
                            <label
                              style={{ fontWeight: 'bold' }}
                              htmlFor="client"
                            >
                              FECHA Y HORA DE PARTIDA
                            </label>
                            <br />
                            <span>
                              {moment(flight.datetimeDeparture).format(
                                'DD-MM-YYYY HH:mm'
                              )}
                            </span>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group">
                            <label
                              style={{ fontWeight: 'bold' }}
                              htmlFor="client"
                            >
                              FECHA Y HORA DE REGRESO
                            </label>
                            <br />
                            <span>
                              {moment(flight.datetimeReturn).format(
                                'DD-MM-YYYY HH:mm'
                              )}
                            </span>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ))}

                  <Row>
                    {!isPackage && (
                      <React.Fragment>
                        <Col md={3}>
                          <div className="form-group">
                            <label
                              style={{ fontWeight: 'bold' }}
                              htmlFor="client"
                            >
                              COSTO DE COMPRA
                            </label>
                            <br />
                            <Badge style={{ backgroundColor: '#5FB404' }}>
                              {numeral(flight.buyprice).format('$0,0.00')}
                            </Badge>
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="form-group">
                            <label
                              style={{ fontWeight: 'bold' }}
                              htmlFor="client"
                            >
                              PRECIO DE VENTA
                            </label>
                            <br />
                            <Badge style={{ backgroundColor: '#0489B1' }}>
                              {numeral(flight.price).format('$0,0.00')}
                            </Badge>
                          </div>
                        </Col>
                      </React.Fragment>
                    )}
                    <Col md={3}>
                      <div className="form-group">
                        <label style={{ fontWeight: 'bold' }} htmlFor="client">
                          OPERADOR
                        </label>
                        <br />
                        <span>
                          {flight.operator !== null
                            ? flight.operator.label
                            : ''}
                        </span>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div className="form-group">
                        <label style={{ fontWeight: 'bold' }} htmlFor="client">
                          COMENTARIOS
                        </label>
                        <br />
                        <span>{flight.comments}</span>
                      </div>
                    </Col>
                  </Row>
                  {/* //DONE Serge Paty - Colocar el "Me Interesa"  */}
                </div>
              );
            })}
          </Col>
        </Row>
        <Button
          bsStyle="primary"
          onClick={() =>
            this.props.dispatch({ type: K.OPEN_MODAL_ADD, payload: 'flight' })
          }
        >
          Agregar Vuelo
        </Button>
      </div>
    );
  }
}

export default connect((state) => ({ Quotations: state.Quotations }))(
  flightQuotation
);



// WEBPACK FOOTER //
// ./src/views/Quotations/cards/flightQuotation.js